import { createMachine } from 'xstate'

export const upgradePlanMachine = ({ initial = 'selectPlan' }: { initial: string }) =>
  createMachine({
    id: 'upgradePlan',
    initial,
    states: {
      selectPlan: {
        on: {
          CONTINUE_TO_PAYMENT: 'payment',
          PROVIDE_REASON: 'provideReason',
        },
      },
      provideReason: {
        on: {
          CANCEL_SUCCESS: 'cancelSuccess',
        },
      },
      cancelSuccess: {},
      payment: {
        on: {
          SELECT_PLAN: 'selectPlan',
          PAYMENT_SUCCEEDED: 'paymentSuccess',
        },
      },
      paymentSuccess: {
        on: {
          CONTINUE: 'success',
        },
      },
      success: {},
    },
  })
